import React from 'react';

import { ChartsHeader } from '../../components';
import LineChartEDAreviewTrend from '../../components/Charts/LineChartEDAreviewTrend';

const LineEDAreviewTrend = ({category, title}) => (
  <div className="p-2 md:p-2 bg-white rounded-3xl">
  {/* <div> */}
    {/* <ChartsHeader category={"리뷰 건수 Trend"} title="" /> */}
    <div className="w-full px-8"> {/* 좌우 패딩 2rem 추가 */}
      <LineChartEDAreviewTrend />
    </div>
  </div>
);

export default LineEDAreviewTrend;
